import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeaturesSection from '../components/home/FeaturesSection';
import ProductCategories from '../components/home/ProductCategories';
import ProductGallery from '../components/home/ProductGallery';
import FactoryShowcase from '../components/home/FactoryShowcase';
import CertificatesSection from '../components/home/CertificatesSection';
import Calculator from '../components/home/Calculator';
import CasesSection from '../components/home/CasesSection';
import LocationSection from '../components/home/LocationSection';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <FeaturesSection />
      <ProductCategories />
      <ProductGallery />
      <FactoryShowcase />
      <CertificatesSection />
      <Calculator />
      <CasesSection />
      <LocationSection />
    </div>
  );
};

export default HomePage;